import React from 'react';

//CORE COMPONENTS
import { IntegratorRoot } from '../../../components-core/packages/components-core/dist/integrator-root/index';
import { Breakpoints } from '../../../components-core/packages/components-core/dist/helpers';
import { ThemeProvider } from '../../../components-core/packages/components-core/dist/theme-provider';
import styled from 'styled-components';

import {
    Container,
    ContainerGutter,
    ContainerPadding
} from '../../../components-core/packages/components-core/dist/container/index';


import caddy from './caddy-style.png'
import transporter from './tr-panelvan.png'
import crafter from './crafter-okul.png'
import caravelle from './care-highline.png'
import amarok from './aventura.png'

//3RD PARTY
import MaintenancePrice from './MaintenancePrice';

const UnorderedList = styled.div`
    display: grid;
    grid-gap: 52px;
    grid-template-columns: repeat(3, 1fr);
    list-style: none;

    @media screen and (max-width: 960px) {
        grid-template-columns: repeat(2, 1fr);
    }

    @media screen and (max-width: 560px) {
        grid-template-columns: repeat(1, 1fr);
    }
`;

class MaintenanceCards extends React.Component {
    renderPriceAreas() {

            const dummyData = dataListMode1;
            const newData = [];

            dummyData.forEach(dataObj => {
                if (dataObj.title) {
                    newData.push(dataObj);
                }
            })

            return newData.map(data => 
                <li style={{ float: 'left', position: 'relative' }} >
                    <MaintenancePrice data={data}/>
                </li>
            )
        
    }

    render() {

        const ContainerPaddingGrid = ContainerPadding.grid002;

        return (
            <ThemeProvider>
                <Container 
                    padding={{
                        left: {
                            [Breakpoints.b560]: ContainerPaddingGrid,                            
                        },
                        right: {
                            [Breakpoints.b560]: ContainerPaddingGrid,                            
                        }
                    }}
                >
                    <UnorderedList>
                        {this.renderPriceAreas()}
                    </UnorderedList>
                </Container>
            </ThemeProvider>
        )
    }
}

export default MaintenanceCards;

const dataListMode1 = [
    {
        'title': 'Caddy',
        'price': '1.064' + ' ₺',
        'image': caddy,
        'backgroundColor':'#b99e8c'
    },
    {
        'title': 'Crafter',
        'price': '1.139' + ' ₺',
        'image': crafter,
        'backgroundColor':'#dedede'
    },
    {
        'title': 'Amarok',
        'price': '1.429' + ' ₺',
        'image': amarok,
        'backgroundColor':'#002048'
    },
    {
        'title': 'Transporter',
        'price': '1.295' + ' ₺',
        'image': transporter,
        'backgroundColor':'#bebebe'
    },

 

]
